module.exports = __webpack_public_path__ + "static/media/basin.c97f0142.svg";